class Cookies {
    static get(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");

        if (parts.length !== 2) {
            return null;
        }

        return decodeURIComponent(parts.pop().split(";").shift());
    }

    static getAll() {
        let cookies = {};
        let value = "; " + document.cookie;

        value.split("; ").forEach(
            (cookieString) => {
                let cookieParts = cookieString.split('=');
                cookies[cookieParts[0]] = decodeURIComponent(cookieParts.slice(1).join(''));
            }
        );

        return cookies;
    }

    static set(name, value) {
        let date = new Date();
        value = encodeURIComponent(value);

        // Set it expire in a year
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));

        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/; domain=" + window.location.hostname;
    }

    static delete(name) {
        const date = new Date();

        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

        document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/; domain=" + window.location.hostname;
    }
}

export default Cookies;
